import { useIsMobile } from "@/hooks/useIsMobile";

// A whisper-thin static noise texture over the entire site — the kind of
// detail that separates a premium editorial build from a flat template.
// Fixed, pointer-events-none, ~3% opacity: felt more than seen, and never
// competes with copy. No particles, no animation, no cursor tie-in.
//
// Off on mobile/tablet: a fixed, full-viewport layer combined with
// mix-blend-mode forces the browser onto a slower compositing path (it
// can't cheaply promote this to its own layer the way a plain opacity
// layer would), which gets recomputed as content scrolls beneath it —
// a real cost on phones for a 3.5%-opacity texture nobody consciously sees.
export function GrainOverlay() {
  const isMobile = useIsMobile();
  if (isMobile) return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[60] opacity-[0.035] mix-blend-overlay"
      aria-hidden="true"
    >
      <svg width="100%" height="100%">
        <filter id="grain-overlay-filter">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#grain-overlay-filter)" />
      </svg>
    </div>
  );
}
